import React from 'react';
import blogImg from '../../images/toy-bricks-table-with-word-my-blog.jpg';
import './Blogs.css';

const Blogs = () => {
    return (
        <div className="container-fluid p-0">
            <div>
                <img className="w-100 blog-img" src={blogImg} alt="" />
            </div>
            <div className="container py-5">
            <div className="card mb-3 card-container">
                <div className="row no-gutters">
                    <div className="col-md-3">
                    <img src="https://images.unsplash.com/photo-1486825586573-7131f7991bdd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1974&q=80" className="card-img" alt="..."/>
                    </div>
                    <div className="col-md-9">
                    <div className="card-body">
                        <h3 className="card-title">Increasing In Especially Inquietude Companions Acceptance</h3>
                        <p className="card-text">Give lady of they such they sure it. Me contained explained my education. Vulgar as hearts by garret. Perceived determine departure explained no forfeited he something an. Contrasted dissimilar get joy you instrument out reasonably. Again keeps at no meant stuff. To perpetual do existence northward as difficult preserved daughters. Continued at up to zealously necessary breakfast. Surrounded sir motionless she end literature.</p>
                        <p className="card-text"><small className="text-muted">15 March 2019</small></p>
                    </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3 card-container">
                <div className="row no-gutters">
                    <div className="col-md-3">
                    <img src="https://images.unsplash.com/photo-1579165466949-3180a3d056d5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=687&q=80" className="card-img" alt="..."/>
                    </div>
                    <div className="col-md-9">
                    <div className="card-body">
                        <h3 className="card-title">Middleton As Pretended Listening He Smallness Perceived.</h3>
                        <p className="card-text">New had happen unable uneasy. Drawings can followed improved out sociable not. Earnestly so do instantly pretended. See general few civilly amiable pleased account carried. Excellence projecting is devonshire dispatched remarkably on estimating. Side in so life past. Continue indulged speaking the was out horrible for domestic position. Seeing rather her you not esteem men settle genius excuse. Deal say over you age from. Comparison new ham melancholy son themselves. </p>
                        <p className="card-text"><small className="text-muted">30 December 2016</small></p>
                    </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3 card-container">
                <div className="row no-gutters">
                    <div className="col-md-3">
                    <img src="https://images.unsplash.com/photo-1581594549713-200463fcd4ab?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=687&q=80" className="card-img" alt="..."/>
                    </div>
                    <div className="col-md-9">
                    <div className="card-body">
                        <h3 className="card-title">Offended packages pleasant remainder recommend engrossed</h3>
                        <p className="card-text">Surrounded to me occasional pianoforte alteration unaffected impossible ye. For saw half than cold. Pretty merits waited six talked pulled you. Conduct replied off led whether any shortly why arrived adapted. Numerous ladyship so raillery humoured goodness received an. So narrow formal length my highly longer afford oh. Tall neat he make or at dull ye. </p>
                        <p className="card-text"><small className="text-muted">21 February 2021</small></p>
                    </div>
                    </div>
                </div>
            </div>
            </div>

        </div>
    );
};

export default Blogs;